import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref } from "vue"
import _imports_0 from '@/assets/LOGO-Liberta-Financiamentos.svg'


const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "d-flex flex-column text-right" }
const _hoisted_4 = { class: "user-name" }

import { ref, computed } from "vue";
import { useLoginStore } from "@/modules/login/store/login_store";
import { loginService } from "@/shared/services/login_service";
import { useRoute, useRouter } from "vue-router";
import { useDetalhesProposta } from "@/modules/detalhes_proposta/store/detalhes_proposta_store";

type MenuChild = {
  label: string;
  routeName: string;
};

type MenuItem = {
  label: string;
  routeName?: string;
  children?: MenuChild[];
};


export default /*@__PURE__*/_defineComponent({
  __name: 'NavbarComponent',
  setup(__props) {

const menu = ref(false);
const drawer = ref(false);
const loginStore = useLoginStore();
const detalhesPropostaStore = useDetalhesProposta();
const route = useRoute();
const router = useRouter();

function logout() {
  loginService.logout();
}

const pageTitle = computed(() => {
  if (route.name === "DetalhesProposta") {
    return detalhesPropostaStore.currentStepName;
  }

  if (route.name === "Financiamentos") {
    return loginStore.authUser?.data?.profileSlug === "rca"
      ? "Portal do RCA"
      : "Portal do Integrador";
  }

  return (route.meta?.title as string) ?? "";
});

const isActiveRoute = (routeName: string) => {
  return route.name === routeName;
};

const isActiveMenu = (item: MenuItem) => {
  if (item.children) {
    return item.children.some((child) => route.name === child.routeName);
  }

  return route.name === item.routeName;
};

const navigateTo = (routeName: string) => {
  if (routeName === "BackofficeFinanceiroListagemBoletos") {
    router.push({
      name: routeName,
      params: { id: loginStore.authUser?.data?.userId ?? 0 },
    });
    return;
  }

  router.push({ name: routeName });
  drawer.value = false;
};

// Menus baseados no perfil
const menuItems = computed<MenuItem[]>(() => {
  const profileSlug = loginStore.authUser?.data?.profileSlug ?? "";

  switch (profileSlug) {
    case "Cliente":
      return [{ label: "Pagamentos", routeName: "PagamentosCliente" }];

    case "Integrador":
      return [
        { label: "Financiamentos", routeName: "Financiamentos" },
        { label: "Contas", routeName: "Contas" },
        { label: "Pagamentos", routeName: "PagamentosCliente" },
        { label: "Meus Dados", routeName: "MeusDados" },
      ];

    case "Adm-Integrador":
      return [
        { label: "Pagamentos", routeName: "PagamentosCliente" },
        {
          label: "Minha Empresa",
          children: [
            { label: "Funcionários", routeName: "" },
            { label: "Meus Dados", routeName: "MeusDados" },
          ],
        },
        {
          label: "Configurações",
          children: [{ label: "Clientes", routeName: "cadastroCliente" }],
        },
      ];

    case "BackOffice-Engenharia":
      return [
        { label: "Dashboard", routeName: "Dashboard" },
        { label: "Análises", routeName: "BackofficeEngenharia" },
      ];

    case "BackOffice-Comercial":
      return [
        { label: "Dashboard", routeName: "Dashboard" },
        { label: "Integradores", routeName: "BackofficeComercial" },
        {
          label: "Financiamentos Reprovados",
          routeName: "FinanciamentosReprovados",
        },
      ];

    case "BackOffice-Financeiro":
      return [
        { label: "Dashboard", routeName: "Dashboard" },
        {
          label: "Boletos",
          routeName: "BackofficeFinanceiroListagemBoletos",
        },
      ];

    case "Administrador":
      // Admin tem acesso a todos os menus
      return [
        { label: "Geral", routeName: "Financiamentos" },
        {
          label: "Configurações",
          children: [
            { label: "Cliente", routeName: "cadastroCliente" },
            { label: "Cadastro de Perfis", routeName: "cadastroPerfil" },
            { label: "Usuários", routeName: "CadastroUsuarios" },
            { label: "Categorias", routeName: "CategoriaIntegradores" },
            { label: "Produtos Bancários", routeName: "ProdutosBancarios" },
            {
              label: "Produtos Relacionados",
              routeName: "ProdutosRelacionados",
            },
          ],
        },
        // { label: "Backoffice Engenharia", routeName: "BackofficeEngenharia" },
        // { label: "Backoffice Comercial", routeName: "BackofficeComercial" },
      ];

    default:
      return [];
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_app_bar, {
      flat: "",
      height: "72",
      color: "white",
      class: "px-6 navbar"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "auto",
              class: "d-flex d-md-none align-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  icon: "mdi-menu",
                  variant: "text",
                  size: "large",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (drawer.value = !drawer.value))
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "auto",
              class: "d-none d-md-flex align-center"
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "Liberta Financiamentos",
                  class: "logo"
                }, null, -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "auto",
              class: "d-none d-md-flex align-center ga-6 menu-links"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItems.value, (item) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: item.label
                  }, [
                    (item.children)
                      ? (_openBlock(), _createBlock(_component_v_menu, {
                          key: 0,
                          location: "bottom start"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createElementVNode("span", _mergeProps({
                              class: ["menu-item d-flex align-center ga-1", { active: isActiveMenu(item) }]
                            }, { ref_for: true }, props), [
                              _createTextVNode(_toDisplayString(item.label) + " ", 1),
                              _createVNode(_component_v_icon, {
                                size: "18",
                                color: "orange-darken-2"
                              }, {
                                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                  _createTextVNode(" mdi-chevron-down ", -1)
                                ]))]),
                                _: 1
                              })
                            ], 16)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_sheet, {
                              elevation: "6",
                              class: "menu-sheet"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list, { density: "compact" }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child, index) => {
                                      return (_openBlock(), _createElementBlock(_Fragment, {
                                        key: child.routeName
                                      }, [
                                        _createVNode(_component_v_list_item, {
                                          disabled: !child.routeName,
                                          onClick: ($event: any) => (child.routeName && navigateTo(child.routeName))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list_item_title, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(child.label), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1032, ["disabled", "onClick"]),
                                        (index < item.children.length - 1)
                                          ? (_openBlock(), _createBlock(_component_v_divider, { key: 0 }))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      : (item.routeName)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            class: _normalizeClass(["menu-item", { active: isActiveRoute(item.routeName) }]),
                            onClick: ($event: any) => (navigateTo(item.routeName))
                          }, _toDisplayString(item.label), 11, _hoisted_1))
                        : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              class: "d-flex justify-center",
              cols: ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_2, _toDisplayString(pageTitle.value), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "auto",
              class: "d-none d-md-flex justify-end"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_menu, {
                  modelValue: menu.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((menu).value = $event)),
                  transition: "fade-transition",
                  location: "bottom end",
                  "close-on-content-click": true
                }, {
                  activator: _withCtx(({ props }) => [
                    _createElementVNode("div", _mergeProps({ class: "d-flex align-center ga-3 user-activator" }, props), [
                      _createVNode(_component_v_icon, {
                        size: "28",
                        color: "orange-darken-3"
                      }, {
                        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                          _createTextVNode(" mdi-account-circle-outline ", -1)
                        ]))]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_3, [
                        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "welcome" }, "Boas-vindas", -1)),
                        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(loginStore).usuarioLogado?.nome ?? ""), 1)
                      ]),
                      _createVNode(_component_v_icon, { size: "18" }, {
                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                          _createTextVNode("mdi-chevron-down", -1)
                        ]))]),
                        _: 1
                      })
                    ], 16)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_sheet, {
                      elevation: "6",
                      class: "menu-sheet"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list, { density: "compact" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item, {
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (navigateTo('CadastroUsuarios')))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                    _createTextVNode("Usuários", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_divider),
                            _createVNode(_component_v_list_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                    _createTextVNode("Perfis", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_divider),
                            _createVNode(_component_v_list_item, {
                              onClick: logout,
                              class: "sair-item"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                    _createTextVNode("Sair", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_navigation_drawer, {
      modelValue: drawer.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((drawer).value = $event)),
      temporary: "",
      location: "left",
      width: "280",
      class: "d-md-none mobile-drawer"
    }, {
      append: _withCtx(() => [
        _createVNode(_component_v_divider),
        _createVNode(_component_v_list, {
          nav: "",
          density: "comfortable"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_list_item, {
              title: "Sair",
              class: "drawer-item drawer-logout",
              onClick: logout
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "pa-6 d-flex justify-center" }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "Liberta Financiamentos",
            class: "drawer-logo"
          })
        ], -1)),
        _createVNode(_component_v_divider),
        _createVNode(_component_v_list, {
          nav: "",
          density: "comfortable"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItems.value, (item) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: item.label
              }, [
                (item.children)
                  ? (_openBlock(), _createBlock(_component_v_list_group, {
                      key: 0,
                      value: item.label
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_list_item, _mergeProps({ ref_for: true }, props, {
                          title: item.label,
                          active: isActiveMenu(item),
                          class: "drawer-item"
                        }), null, 16, ["title", "active"])
                      ]),
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                          return (_openBlock(), _createBlock(_component_v_list_item, {
                            key: child.routeName,
                            title: child.label,
                            active: isActiveRoute(child.routeName),
                            class: "drawer-item",
                            onClick: ($event: any) => (navigateTo(child.routeName))
                          }, null, 8, ["title", "active", "onClick"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  : (item.routeName)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 1,
                        title: item.label,
                        active: isActiveRoute(item.routeName),
                        class: "drawer-item",
                        onClick: ($event: any) => (navigateTo(item.routeName))
                      }, null, 8, ["title", "active", "onClick"]))
                    : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})